;(function($, undefined){

    $.fn.isOnScreen = function(){
        var current_window = $(window),
            margin = 200,
            viewport = {
                top : current_window.scrollTop(),
                left : current_window.scrollLeft()
            },
            bounds = this.offset();

        viewport.right = viewport.left + current_window.width();
        viewport.bottom = viewport.top + current_window.height();

        bounds.right = bounds.left + this.outerWidth();
        bounds.bottom = bounds.top + this.outerHeight();

        return (!(viewport.right < bounds.left || viewport.left > bounds.right || viewport.bottom - margin < bounds.top || viewport.top + margin > bounds.bottom));
    };

    function featureAdvertising() {
        $('.featureAdvertising').insertAfter('.articleContent > p:first-of-type');
    }

    function initFeatureFunctions() {
        if ($('.feature_section').length > 0) {
            featureAdvertising();
        }
    }

    rnn.modules.register('featureItems', {
        init: initFeatureFunctions
    });

})(jQuery);
